import DrawerTab, { TRANSITION_DURATION_MS } from './DrawerTab';

export default DrawerTab;
export { TRANSITION_DURATION_MS };
